import request from "@/helper/request";

// 查询所有站点
export function getSites(data) {
  return request({
    url: "/json/sitecrowd/list",
    method: "post",
    data: data
  });
}

// 切换站点通知后台
export function setSites(data) {
  return request({
    url: "/json/sitecrowd/set",
    method: "post",
    data: data
  });
}

// 定制产品
export function addSelfProduction(data) {
  return request({
    url: "/json/order/placeOrder",
    method: "post",
    data: data
  });
}


// 查询某个站点信息
export function getSiteInfoById(data) {
  return request({
    url: "/json/sitecrowd/read",
    method: "post",
    data: data
  });
}

// 查询导航栏
export function getTabs(data) {
  return request({
    url: "/json/category/tree",
    method: "post",
    data: data
  });
}

// 文章类分页查询
export function getContents(data) {
  return request({
    url: "/json/content/list",
    method: "post",
    data: data
  });
}

// 文章类详情
export function getContentsDetail(data) {
  return request({
    url: "/json/content/read",
    method: "post",
    data: data
  });
}

// 产品分类列表
export function getProductTypeNavList(data) {
  return request({
    url: "/json/producttype/list",
    method: "post",
    data: data
  });
}

// 产品相关导航查询
export function getProductNav(data) {
  return request({
    url: "/json/producttype/tree",
    method: "post",
    data: data
  });
}

export function getSearchProductType(data) {
  return request({
    url:"/json/producttype/pulldown",
    method: "post",
    data: data
  });
}

// 111
export function getProductInfo(data) {
  return request({
    url: "/json/producttype/read",
    method: "post",
    data: data
  });
}

// 产品列表字段
export function getProductTpyeListFields(data) {
  return request({
    url: "/json/product/fields",
    method: "post",
    data: data
  });
}

// 产品列表
export function getProductTpyeList(data) {
  return request({
    url: "/json/product/list",
    method: "post",
    data: data
  });
}

// 反馈
export function reportApi(data) {
  return request({
    url: "/json/guestbook/add",
    method: "post",
    data: data
  });
}

//碎片管理

export function getBlokcList(data) {
  return request({
    url: "/json/block/list",
    method: "post",
    data: data
  });
}


//分享相关

// /json/share/add

export function addShare(data) {
  return request({
    url: "/json/share/add",
    method: "post",
    data: data
  });
}

    
//站点切换
export function chageSite(data) {
  return request({
    url: "/json/sitecrowd/list",
    method: "post",
    data: data
  });
}
//注册
export function register(data) {
  return request({
    url: "/json/member/register",
    method: "post",
    data: data
  });
}
//修改个人资料

// /json/member/edit
export function editMember(data) {
  return request({
    url: "/json/member/edit",
    method: "post",
    data: data
  });
}
// 修改密码  /json/member/psdedit


export function getUserInfo(data) {
  return request({
    url: "/json/member/read",
    method: "post",
    data: data
  });
}


export function psdedit(data) {
  return request({
    url: "/json/member/psdedit",
    method: "post",
    data: data
  });
}

// 找回密码

export function findPsd(data) {
  return request({
    url: "/json/member/getpsd",
    method: "post",
    data: data
  });
}

// 发送短信验证码【用于中文版】

export function sendSMS(data) {
  return request({
    url: "/json/base/smsCode",
    method: "post",
    data: data
  });
}

// 发送邮件验证码【用于英文版】

export function sendEmail(data) {
  return request({
    url: "/json/base/emailCode",
    method: "post",
    data: data
  });
}

//意见建议
export function guestbook(data) {
  return request({
    url: "/json/guestbook/add",
    method: "post",
    data: data
  });
}

//栏位查看的相关接口

export function categoryread(data) {
  return request({
    url: "/json/category/read",
    method: "post",
    data: data
  });
}

// 发票管理相关接口

export function getBillField(data) {
  return request({
    url: "/json/bill/fields",
    method: "post",
    data: data,
  });
}


//  添加发票信息

export function addBill(data) {
  return request({
    url: "/json/bill/add",
    method: "post",
    data: data,
  });
}


// 修改发票信息
export function editBill(data) {
  return request({
    url: "/json/bill/edit",
    method: "post",
    data: data,
  });
}

//查询指定发票信息

export function readBill(data) {
  return request({
    url: "/json/bill/read",
    method: "post",
    data: data,
  });
}


//发票分页搜索及查询


export function listBill(data) {
  return request({
    url: "/json/bill/list",
    method: "post",
    data: data,
  });
}


//删除发票信息
export function deleteBill(data) {
  return request({
    url: "/json/bill/delete",
    method: "post",
    data: data,
  });
}


//地址管理

// 地址

export function getAddressField(data) {
  return request({
    url: "/json/address/fields",
    method: "post",
    data: data,
  });
}

//添加收获地址


// /json/address/add

export function addAdress(data) {
  return request({
    url: "/json/address/add",
    method: "post",
    data: data,
  });
}

///json/address/edit  修改收获地址


export function editAddress(data) {
  return request({
    url: "/json/address/edit",
    method: "post",
    data: data,
  });
}

//查询单个收获地址  /json/address/read

export function readAddress(data) {
  return request({
    url: "/json/address/read",
    method: "post",
    data: data,
  });
}

//  地址列表

export function listAddress(data) {
  return request({
    url: "/json/address/list",
    method: "post",
    data: data,
  });
}

// 删除列表

export function deleteAddress(data) {
  return request({
    url: "/json/address/delete",
    method: "post",
    data: data,
  });
}

//纸质资料申请接口

export function paperReq(data) {
  return request({
    url: "/json/application/add",
    method: "post",
    data: data,
  });
}
